import React from 'react';
import { Input } from 'semantic-ui-react';
import { FormattedMessage, useIntl } from 'react-intl';
import FormattedHTMLMessage from '@/components/FormattedHTMLMessage';
import urls, { linkPrefixes } from '@/constants/urls';
import CopyButton from '@/components/buttons/CopyButton';
import Dialog from '@/components/dialogs/Dialog';
import Selectors from '../hooks/selectors';
import Events from '../hooks/events';

const AboutDialog = ({ theme }) => {
  const intl = useIntl();
  const { version, dreName, authToken } = Selectors.useAboutDialog();
  const hide = Events.useShowAbout();
  return (
    <Dialog
      className="aridhia-about-dialog"
      icon="info circle"
      onClose={() => hide({ show: false })}
      theme={theme}
      title={intl.formatMessage({ id: 'about.title' }, { dreName })}
    >
      {version && (
        <p>
          <FormattedMessage id="about.version" values={{ version }} />
        </p>
      )}
      <p>
        <FormattedMessage id="about.copyright" values={{ year: new Date().getFullYear() }} />
      </p>
      <FormattedHTMLMessage id="about.fair.api.docs.hostname" values={{ urlDocs: urls.DOCS }} />
      <Input
        fluid
        labelPosition="right"
        label={<CopyButton value={`${linkPrefixes.HTTPS}${urls.API}`} message="url.copy" />}
        value={`${linkPrefixes.HTTPS}${urls.API}`}
      />
      {authToken && (
        <div className="aridhia-about-dialog-access-container">
          <FormattedMessage id="about.token" />
          <Input
            fluid
            labelPosition="right"
            label={<CopyButton value={authToken} message="token.copy" />}
            value={authToken}
          />
        </div>
      )}
    </Dialog>
  );
};

export default AboutDialog;
